const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
};

export const formElementFields = [
  {
    id: "complaint_id",
    label: "Complaint",
    placeHolder: "Select",
    type: "select",
    md: 6,
    inputProps: {
      maxLength: 100,
    },
    isRequired: true,
    options: [],
    disabled:true,
  },
  {
    id: "progress_id",
    label: "Progress Item",
    placeHolder: "Select",
    type: "select",
    md: 6,
    inputProps: {
      maxLength: 100,
    },
    options:[],
    isRequired: true,
  },
  {
    id: "added_by",
    label: "Added By",
    placeHolder: "Enter name",
    type: "select",
    md: 6,
    inputProps: {
      maxLength: 100,
    },
    options:[],
    isRequired: true,
  },
   {
    id: "date",
    label: "Date",
    placeHolder: "Select date",
    type: "date",
    md: 6,
    isRequired: false,
  },

  {
    id: "description",
    label: "Details",
    placeHolder: "Enter cost details",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 500,
      rows: 3,
    },
    isRequired: true,
  },
    {
    id: "amount",
    label: "Amount",
    placeHolder: "Enter amount",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 4,
  },
  {
    id: "invoice_reference",
    label: "Invoice Reference",
    placeHolder: "Enter invoice reference",
    type: "text",
    md: 4,
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: false,
  },
 
  {
    id: "supplier",
    label: "Supplier",
    placeHolder: "Enter supplier",
    type: "text",
    md: 4,
    isRequired: false,
    options: [''],
  },
 
];
